export const removeMask = (value) => {
  if (typeof value !== 'string') return value;

  if (value.includes('@')) {
    // Email – mantém caracteres válidos
    return value.replace(/[^a-zA-Z0-9@()_.]/g, '');
  }

  return value.replace(/[^0-9+]/g, '');
};

export const formatUserList = (formValues, clubForms) => {
  const userInfoObj = {};
  const contactList = [];
  const documentList = [];
  let addressList = [];

  clubForms.formFields.forEach((field) => {
    const { fieldName, type, inputType, fieldType } = field;

    switch (type) {
      case 'contactList':
        if (formValues[fieldName]) {
          contactList.push({
            type: fieldName,
            value: formValues[fieldName].toString(),
          });
        }
        userInfoObj.contactList = contactList;
        break;

      case 'documentList':
        if (formValues[fieldName]) {
          documentList.push({
            type: fieldName,
            value: formValues[fieldName].toString().replace(/\D+/g, ''),
          });
        }
        userInfoObj.documentList = documentList;
        break;

      case 'addressList':
        if (formValues.cep) {
          addressList = [
            {
              zipCode: formValues.cep,
              streetAve: formValues.streetAve,
              neighborhood: formValues.neighborhood,
              number: formValues.number,
              city: formValues.city,
              state: formValues.state,
              extra: formValues.complement,
            },
          ];
          userInfoObj.addressList = addressList;
        }
        break;

      case 'others':
        if (formValues[fieldName]) {
          const val =
            inputType === 'date'
              ? new Date(formValues[fieldName]).getTime()
              : formValues[fieldName];
          userInfoObj[fieldName] = val;
        }
        break;

      case 'root':
        if (formValues[fieldName]) {
          const val =
            inputType === 'date'
              ? new Date(formValues[fieldName]).getTime()
              : formValues[fieldName];
          userInfoObj[fieldName] = val;
        }
        break;

      default:
        break;
    }
  });

  userInfoObj.partnerId = clubForms.partnerId;
  userInfoObj.partnerName = clubForms.clubeId;

  return {
    partnerInfo: { ...userInfoObj },
    clubeId: clubForms.clubeId,
    token:
      clubForms.tokenType === 'cpf'
        ? formValues[clubForms.tokenType].replace(/\D+/g, '')
        : formValues[clubForms.tokenType],
    cellphone: formValues.cellPhone,
    name: formValues.name,
  };
};
